import AuthenticatedController from './AuthenticatedController';
import * as APIRoutes from '@mm/api-routes';
import ButtonModel from '../model/ButtonModel';
import {
  SuppressionSettingsCSVModel,
  SuppressionSettingsCSVResponse,
  SuppressionSettingsModel,
} from '../model/SuppressionSettingsModel';
import {
  ContactsCsvImportJobResponse,
  ContactsCSVType,
  CsvImportOptions,
} from './ContactsCotroller';

export default class SuppressionSettingsController extends AuthenticatedController {
  static createSettings(
    facebookPageId: number,
  ): Promise<SuppressionSettingsModel> {
    return super.post(`${APIRoutes.SUPPRESSION_SETTINGS}/${facebookPageId}`);
  }

  static getSettings(
    facebookPageId: number,
  ): Promise<SuppressionSettingsModel[]> {
    return super.get(`${APIRoutes.SUPPRESSION_SETTINGS}/${facebookPageId}`);
  }

  static getUploadedCsvFiles(
    facebookPageId: number,
    page: number = 1,
    perPage: number = 100,
    kind?: SuppressionSettingsCSVModel['kind'],
  ): Promise<SuppressionSettingsCSVResponse> {
    return super.get(
      `${APIRoutes.SUPPRESSION_SETTINGS}/suppression_csvs/${facebookPageId}`,
      {
        page,
        perPage,
        kind,
      },
    );
  }

  static updateSettings(
    facebookPageId: number,
    entity: Partial<SuppressionSettingsModel>,
  ): Promise<SuppressionSettingsModel> {
    return super.put(
      `${APIRoutes.SUPPRESSION_SETTINGS}/${facebookPageId}`,
      entity,
    );
  }

  static createCSV(
    facebookPageId: number,
    entity:
      | Omit<CsvImportOptions, 'facebookPageId'>
      | {
          googleAccountId: number;
          googleSpreadsheetId: number | string;
          googleSpreadsheetTitle: string;
          googleSheetId: number;
          googleSheetTitle: string;
        },
  ): Promise<SuppressionSettingsCSVModel> {
    return super.post(
      `${APIRoutes.SUPPRESSION_SETTINGS}/create_csv/${facebookPageId}`,
      entity,
    );
  }

  static updateCSV(
    csvId: number,
    entity: { uploaded: boolean },
  ): Promise<SuppressionSettingsCSVModel> {
    return super.put(
      `${APIRoutes.SUPPRESSION_SETTINGS}/update_csv/${csvId}`,
      entity,
    );
  }

  static deleteCSV(csvId: number): Promise<void> {
    return super.delete(
      `${APIRoutes.SUPPRESSION_SETTINGS}/delete_csv/${csvId}`,
    );
  }
}
